import React from 'react';
import DevicesThresholdsTable from 'components/molecules/admin-panel/forms/devices/table';
import BaseGrid from 'components/atoms/base-grid';
import AdminPanelPatientThresholdsForm from 'components/molecules/admin-panel/forms/patient-thresholds';
import { isAdminModule } from 'infrastructure/functions';
import useUser from 'utils/useUser';

import s from '../styles.module.scss';
import DeviceOrderSpecification from './device-order-specification';

import type { ModuleType, RpmStatuses } from 'infrastructure/enums';

interface IAdminTabbedFormDevicesThresholdsProps {
  patientGuid: string;
  module: ModuleType;
  rpmStatus?: RpmStatuses;
  readOnly?: boolean;
}

const AdminTabbedFormDevicesThresholds: React.FC<
  IAdminTabbedFormDevicesThresholdsProps
> = (props) => {
  const { patientGuid, module, rpmStatus, readOnly } = props;

  const { isPatient } = useUser();

  return (
    <BaseGrid
      columns={1}
      rowGap={22}
      className={s['devises-thresholds-wrapper']}
    >
      <DevicesThresholdsTable
        patientGuid={patientGuid}
        module={module}
        rpmStatus={rpmStatus}
        readOnly={readOnly}
      />
      {isAdminModule(module) && (
        <DeviceOrderSpecification
          patientGuid={patientGuid}
          readOnly={readOnly}
        />
      )}
      {!isPatient && (
        <AdminPanelPatientThresholdsForm
          patientGuid={patientGuid}
          module={module}
          readOnly={readOnly}
        />
      )}
    </BaseGrid>
  );
};

export default AdminTabbedFormDevicesThresholds;
